export default __webpack_public_path__ + "static/home-7d8f771de771c316d8fb439e7d31da7f.gif";